var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import './FullBleedImageVideoModal.scss';
import closeButton from '../../assets/images/fullBleedImageVideo/close.png';
import parse from 'html-react-parser';
var Modal = function (data) {
    var _a = useState(''), modalHTML = _a[0], setModalHTML = _a[1];
    useEffect(function () {
        if (data.modalData.media_url.includes('vimeo')) {
            //Vimeo
            fetch("https://vimeo.com/api/oembed.json?url=" + data.modalData.media_url)
                .then(function (res) { return res.json(); })
                .then(function (data) {
                setModalHTML(data.html);
            });
        }
    }, []);
    var wistiaId;
    data.modalData.media_url.includes('wistia')
        ? (wistiaId =
            data.modalData.media_url.split('/')[data.modalData.media_url.split('/').length - 1])
        : '';
    return (_jsx("div", __assign({ className: "relative md:flex md:items-center md:justify-center full-bleed-image-video-modal-container" }, { children: _jsx("div", __assign({ className: "fixed full-bleed-image-video-modal-backdrop" }, { children: _jsxs("div", __assign({ className: "full-bleed-image-video-modal-video-player-container md:flex items-center" }, { children: [_jsx("div", __assign({ className: "full-bleed-image-video-modal-close-button" }, { children: _jsx("img", { src: closeButton, onClick: data.closeModal }, void 0) }), void 0),
                    _jsx("div", __assign({ className: "full-bleed-image-video-modal-video-player" }, { children: data.modalData.media_url.includes('vimeo') ? (parse(modalHTML)) : (_jsx("iframe", { src: "//fast.wistia.net/embed/iframe/" + wistiaId, scrolling: "no", name: "wistia_embed", allowFullScreen: true }, void 0)) }), void 0)] }), void 0) }), void 0) }), void 0));
};
export default Modal;
